import { createSelector } from "reselect";

const selectBlog = state => state.blog;

export const selectBlogCollection = createSelector(
    [selectBlog],
    blog => blog.collection
);